import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/"><img src="/Satta.png" alt="" /></Link>
      </div>

      <ul className={`navbar-links ${isMobileMenuOpen ? "active" : ""}`}>
        <li><Link to="/" onClick={() => setIsMobileMenuOpen(false)}>SATTA 786</Link></li>
        <li><Link to="/" onClick={() => setIsMobileMenuOpen(false)}>SATTA CHART</Link></li>
        <li><Link to="/" onClick={() => setIsMobileMenuOpen(false)}>TAJ SATTA WALA</Link></li>
        <li><Link to="/" onClick={() => setIsMobileMenuOpen(false)}>SATTA LEAK</Link></li>
      </ul>

      <div className="navbar-menu-icon" onClick={toggleMenu}>
        {isMobileMenuOpen ? "X" : "☰"}
      </div>
    </nav>
  );
};

export default Navbar;
